/** English strings — combat-readability settings (docs/12 E1-E5). */
export const enClarity = {
  'settings.dmgNumbers': 'Damage Numbers',
  'settings.dmgNumbers.off': 'OFF',
  'settings.dmgNumbers.crits': 'CRITS ONLY',
  'settings.dmgNumbers.all': 'ALL (merged)',
  'settings.shake': 'Screen Shake',
  'settings.shake.off': 'OFF',
  'settings.shake.low': 'LOW',
  'settings.shake.full': 'FULL',
  'settings.effects': 'Effects Intensity',
  'settings.effects.low': 'LOW',
  'settings.effects.medium': 'MEDIUM',
  'settings.effects.high': 'HIGH',
} as const;
